<div class="loginModal">
  <!--
  <p-dialog [header]="'LOGIN_COMPONENT.HEADER' | translate" [visible]="true" [draggable]="true" [closable]="false"
            [resizable]="false">-->
  <p-fieldset [legend]="'LOGIN_COMPONENT.HEADER' | translate" *ngIf="displayLoading == false">
    <div class="container">
      <div *ngIf="showCustomerID" class="group externaLabel">
        <input [(ngModel)]="userToLog.idCustomer" #cid type="text" (keydown)="goToUserId($event)" required autocomplete="-1">
        <span class="highlight"></span>
        <span class="bar"></span>
        <label>{{ 'COMMON.CUSTOMERID' | translate }}</label>
      </div>

      <div class="group externaLabel">
        <input [(ngModel)]="userToLog.idUser" #uid type="text" (keydown)="goToUserPwd($event)" required autocomplete="off">
        <span class="highlight"></span>
        <span class="bar"></span>
        <label>{{ 'COMMON.USERID' | translate }}</label>
      </div>

      <!-- password field should be in form tag to avoid navigator secutity warning-->
      <form>
        <div class="group externaLabel">
          <input [ngModelOptions]="{standalone: true}" [(ngModel)]="userToLog.password" #upwd type="password" required (keydown)="onKeydown($event)" autocomplete="off">
          <span class="highlight"></span>
          <span class="bar"></span>
            <label>{{ 'LOGIN_COMPONENT.LABEL_PASSWORD' | translate }}</label>
        </div>
      </form>
      <div class="group">
        <p-checkbox [label]="'LOGIN_COMPONENT.REMEMBERME_BUTTON' | translate" [(ngModel)]="rememberMe"
                    id="rememberMe" [binary]="true"></p-checkbox>
      </div>
      <div *ngIf="loginFail" class="error">
        <p>{{errorMessage}}</p>
      </div>
      <div class="grid">
<!--        <div class="col-12 connexionAction grid justify-content-center">-->
        <div class="col-12 grid justify-content-center">
          <button pButton id="loginButton" type="button" [icon]="'fa fa-unlock'"
                  [label]="'LOGIN_COMPONENT.CONNEXION_BUTTON' | translate" (click)="askConnexion()"
                  [disabled]="!formIsComplete()"></button>
        </div>
        <div class="col-12 grid justify-content-center mt-4">
          <p class="forgottenPassword"
           (click)="displayForgotten=true">{{'LOGIN_COMPONENT.LABEL_FORGOTTENPASSWORD' | translate }}</p>
          <p class="strongAuth"
             (click)="askWso2Connexion()">{{'LOGIN_COMPONENT.LABEL_STRONGAUTH' | translate }}</p>
        </div>
      </div>

    </div>
  </p-fieldset>
  <!--
  </p-dialog>
  -->

</div>


<div class="forgottenPasswordModal" *ngIf="displayForgotten">
  <p-dialog [(visible)]="displayForgotten" [header]="'LOGIN_COMPONENT.FORGOTTEN_PASSWORD_MODAL_HEADER' | translate" [draggable]="false"
            [closable]="true"
            [resizable]="false"
            [modal]="true" [closeOnEscape]="false">
    <app-forgotten-password (forgottenSuccess)="showSuccessToaster($event)" [customerID]="userToLog.idCustomer"
                            [userID]="userToLog.idUser"></app-forgotten-password>
  </p-dialog>
</div>
<div>
  <p-dialog [header]="'LOGIN_COMPONENT.WSO2_DETECTED_MODAL_HEADER' | translate" [modal]="true" [(visible)]="showWsoRedirectionDialog" [style]="{ width: '28rem' }">
    <span class="p-text-secondary block h-6rem justify-content-center align-content-center mb-2" [style]="{ color: 'black', 'font-size': '0.85rem', 'text-align': 'center'}">{{'WSO2_DETECTED_COMPONENT.WSO2_HAS_TO_BE_REDIRECT_ERROR_MESSAGE_PART_1' | translate}}<br><br>{{'WSO2_DETECTED_COMPONENT.WSO2_HAS_TO_BE_REDIRECT_ERROR_MESSAGE_PART_2' | translate}}</span>
<!--    <div class="flex justify-between gap-2">-->
    <div class="flex flex-row justify-content-evenly">
      <p-button [label]="'WSO2_DETECTED_COMPONENT.ABORT' | translate" severity="secondary" (click)="showWsoRedirectionDialog = false" [style]="{ flex: '1' }" />
      <p-button [label]="'WSO2_DETECTED_COMPONENT.WSO2_REDIRECTION' | translate" (click)="askWso2Connexion()" [style]="{ flex: '1' }" />
    </div>
  </p-dialog>

  <p-dialog [(visible)]="displayLoading" [header]="'APPLICATION_COMPONENT.HEADER' | translate" id="loader" [draggable]="false" [closable]="false" [resizable]="false"
            [modal]="true" [closeOnEscape]="false">
    <app-loader waitingMessage="{{ 'APPLICATION_COMPONENT.MESSAGE' | translate }}"></app-loader>
  </p-dialog>
</div>
